<template>
  <div class="d-flex flex-column gap-3">
    <div class="d-flex justify-content-between align-items-center gap-3">
      <div class="header-info">
        {{ $t("borradores-operacion.form.notas_mensaje_info") }}
      </div>
      <div>
        <DxButton v-bind="secondaryButtonProps($t('borradores-operacion.ui.buttons.nueva_nota'))" icon="plus" @click="nuevaNota()" />
      </div>
    </div>
    <BorradorOperacionNotaCard
      v-for="nota in notas"
      :model="nota"
      :id-borrador-operacion="idBorradorOperacion"
      :key="nota.Id"
      @update:nota="emit('update:notas')"
    />
  </div>
</template>

<script setup lang="ts">
import type { DetailNotaBorradorOperacionModel } from "@/.shared/.api";
import BorradorOperacionNotaCard from "@/components/borradores-operacion/BorradorOperacionNotaCard.vue";
import { secondaryButtonProps } from "@/.shared/helpers/button-helper";
import { DxButton } from "devextreme-vue/button";
import { useModalService } from "@/.shared/services/modal-service";
import { useIntl } from "@/.shared/services/i18n";
import InputBox from "@/.shared/components/dialogs/InputBox.vue";
import { messageBoxResult } from "@/.shared/components/dialogs/message-box";
import { useApi } from "@/.shared/.api/integration";
import { toastError } from "@/.shared/services/notification-service";

const props = defineProps({
  notas: Object as () => DetailNotaBorradorOperacionModel[],
  idBorradorOperacion: {
    type: String,
    required: true,
  },
});

const modal = useModalService();
const intl = useIntl();
const api = useApi();
const emit = defineEmits<{
  (e: "update:notas"): void;
}>();

const nuevaNota = async () => {
  const nota = (await modal.showModal(
    InputBox,
    {
      label: intl.i18n.t("borradores-operacion.form.nota_label"),
      required: true,
      dxInputType: "dxTextArea",
      dxInputProps: {
        placeholder: intl.i18n.t("borradores-operacion.form.nota_placeholder"),
        inputAttr: {
          rows: 5,
        },
      },
    },
    {
      title: undefined,
      width: 500,
      height: 300,
    },
  )) as { result: string; value: string | null };

  if (nota.result == messageBoxResult.ok && nota.value) {
    try {
      await api.callStandardApi("createNotaBorradorOperacion", { showLoading: true }, props.idBorradorOperacion, { Contenido: nota.value });
      emit("update:notas");
    } catch (error) {
      toastError(intl.i18n.t("borradores-operacion.form.nota_error"));
    }
  }
};
</script>
<style lang="scss" scoped>

.header-info {
  color: var(--text-default-caption, #7b7893);
  font-style: italic;
}
</style>
